import { useNavigate, useParams } from 'react-router-dom';
import Page from 'src/components/Page';
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Logo from 'src/components/Logo';
import confirmDoneTask from 'src/api/transaction/confirm-transaction-done-task';
import useLoading from 'src/hooks/useLoading';
import getTransactionTaskMetadata, { TransactionTaskMetadata } from 'src/api/user/get-transaction-task-metadata';
import Progress from 'src/components/Progress';
import { AuthPage } from '../auth/styles';

const ConfirmDoneTask = () => {
	const navigate = useNavigate();
	const { isLoading, setIsLoading } = useLoading(true);
	const [metadata, setMetadata] = useState<TransactionTaskMetadata | null>(null);
	const { id, taskId } = useParams();

	const handleLogin = () => navigate('/auth/login');

	useEffect(() => {
		const setup = async () => {
			try {
				if (!id || !taskId) {
					handleLogin();

					return;
				}

				const taskMetadata = await getTransactionTaskMetadata({ id, taskId }).catch((e) => {
					console.log(e);

					handleLogin();

					throw e;
				});

				setMetadata(taskMetadata);

				await confirmDoneTask(id, taskId);

				setIsLoading(false);
			} catch (e) {
				console.log(e);

				handleLogin();
			}
		};

		setup();
	}, []);

	return (
		<Page title='Quote'>
			<AuthPage>
				{isLoading ? (
					<Progress />
				) : metadata ? (
					<Box
						display='flex'
						flexDirection='column'
						gap='15px'
						alignItems='center'
						sx={{ background: 'white', px: '30px', py: '20px', borderRadius: '3px' }}
					>
						<Logo full />
						<Typography variant='h4'>✅ {metadata.description}</Typography>
						<Typography variant='h4'>Thank you! Your answer has been recorded.</Typography>
					</Box>
				) : null}
			</AuthPage>
		</Page>
	);
};

export default ConfirmDoneTask;
